import { Box } from '@mui/material';
import { Types } from '@scorenco/core';

import { Wrapper } from '../../primitives';

type HtmlSliceProps = {
  slice: Types.ComponentSlicesHtml;
};

export const HtmlSlice = ({ slice }: HtmlSliceProps) => {
  if (!slice.html) {
    return null;
  }

  return (
    <Wrapper marginY={5}>
      <Box
        component="div"
        sx={{ mx: 'auto' }}
        dangerouslySetInnerHTML={{ __html: slice.html }}
      />
    </Wrapper>
  );
};
